export const MIN_LENGTH = 0;
export const MAX_LENGTH = 255;
export const MIN_NUMBER = 0;
export const MAX_NUMBER = 100;
export const DEFAULT_STEP = 1;

export const ERROR_MESSAGES = {
  Required: 'This field is required.',
  Format: 'Wrong value format',
  EmailFormat: 'Please enter a valid email address',
  PostalCodeFormat: 'Postal Code must be 6 characters long with the correct format',
  MinValue: 'Please provide a value higher than ',
  MaxValue: 'Please provide a value not greater than ',
  MaxLength: 'Please limit your entry to ',
  ValueBetween: 'Please select a number between ',
  MinDate: 'Please select a date later than',
};
